import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Upload, Image, message } from "antd";
import axios from "axios";
import "./commonUpload.scss";
import { toast } from "react-toastify";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const CommonUpload = ({
  uploadUrl = `${process.env.REACT_APP_API_URI}/common/upload`,
  fileLimitSize = 5,
  listType = "picture-circle",
  accept = ".png,.jpeg,.jpg",
  setFieldValue,
  fileList: initialFileList = [],
  showRemoveIcon,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState(initialFileList);

  useEffect(() => {
    if (initialFileList.length > 0) {
      setFileList(initialFileList);
    }
  }, [initialFileList]);

  const handlePreview = async (file) => {
    let imageUrl = file.url;
    if (imageUrl && !imageUrl.startsWith("http")) {
      imageUrl = `${process.env.REACT_APP_API_IMG_URI}/${imageUrl}`;
    }
    if (!imageUrl && !file.preview && file.originFileObj) {
      file.preview = await getBase64(file.originFileObj);
      imageUrl = file.preview;
    }
    setPreviewImage(imageUrl);
    setPreviewOpen(true);
  };

  const handleUpload = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append("file", file);
    const token = localStorage.getItem("ACCESS_TOKEN");

    try {
      const response = await axios.post(uploadUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      });

      if (response?.data?.code === 200) {
        const imageUrl = response?.data?.result?.rows?.[0]?.image_url;
        const fullImageUrl = `${process.env.REACT_APP_API_IMG_URI}/${imageUrl}`;
        if (imageUrl) {
          setFieldValue(imageUrl);
          setFileList([
            {
              uid: file.uid,
              name: file.name,
              url: fullImageUrl,
              thumbUrl: fullImageUrl,
              status: "done",
            },
          ]);
          message.success("File uploaded successfully!");
          onSuccess();
        } else {
          message.error("Upload successful, but no image URL received!");
          onError();
        }
      } else {
        message.error("Failed to upload file!");
        onError();
      }
    } catch (error) {
      message.error("Upload failed! Please try again.");
      onError();
    }
  };

  const beforeUpload = (file) => {
    const isLtLimit = file.size / 1024 / 1024 < fileLimitSize;
    if (!isLtLimit) {
      toast.error(`File must be smaller than ${fileLimitSize}MB!`);
    }
    return isLtLimit;
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  return (
    <div style={{ textAlign: "center" }} className="uploadLogo">
      <Upload
        listType={listType}
        fileList={fileList}
        onPreview={handlePreview}
        beforeUpload={beforeUpload}
        accept={accept}
        maxCount={1}
        customRequest={handleUpload}
        showUploadList={{ showRemoveIcon: showRemoveIcon }}
        onRemove={() => {
          setFileList([]);
          setFieldValue("");
        }}
      >
        {fileList.length >= 1 ? null : uploadButton}
      </Upload>

      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </div>
  );
};

export default CommonUpload;
